import { Type } from '@angular/core';

export class Card<T = any> {
  constructor(
    public component: Type<any>,
    public data: T,
    public readonly id: string
  ) {}

  clone(): Card<T> {
    return new Card<T>(this.component, this.data, this.id);
  }
}
